import React from "react";
import { FieldRenderProps } from "react-final-form";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Switch,
} from "@material-ui/core";

import FormControlError from "components/FormControl/FormControlError";
import withFieldControl from "components/FormControl/FieldControl";

import { Container, FormGroupContentWrapper } from "./styles";

type DictionaryItem = {
  value: any;
  label: string;
};

type Props = {
  title: string;
  switchLabel: string;
  required?: boolean;
  inline?: boolean;
  optionWidth?: string;
  disabled?: boolean;
  disabledSwitch?: boolean;
} & FieldRenderProps<any>;

class CheckboxGroupWithSwitchFieldControl extends React.Component<Props> {
  get selected() {
    const { options, input } = this.props;
    const value = input?.value || [];

    return value.map((item: any) => {
      const option = options?.find(
        (findItem: DictionaryItem) => findItem.value.id === item.id,
      );
      return {
        ...option,
        value: { ...option.value, switchState: item.switchState },
      };
    });
  }

  getIsCheckboxSelected = (option: DictionaryItem) =>
    this.selected.find(
      (selectedOption: any) => selectedOption.value.id === option.value.id,
    );

  getIsSwitchSelected = (option: DictionaryItem): boolean => {
    const { input } = this.props;
    const value = input?.value || [];

    return value.find(
      (selectedValue: any) => selectedValue.id === option.value.id,
    )?.switchState;
  };

  onChange = (items: DictionaryItem[] = []) => {
    const value = items.map(item => item.value);
    const event: any = { target: { value } };
    this.props.input.onChange(event);
  };

  onChangeCheckbox = (option: DictionaryItem) => () => {
    const { required } = this.props;

    let items = this.selected || [];
    if (this.getIsCheckboxSelected(option)) {
      items = items.filter(
        (item: DictionaryItem) => item.value.id !== option.value.id,
      );
    } else {
      items.push(option);
    }

    if (!required || items.length > 0) {
      this.onChange(items);
    }
  };

  onChangeSwitch = (option: DictionaryItem) => () => {
    const items = this.selected.map((selectedOption: any) =>
      selectedOption.value.id === option.value.id
        ? {
            ...selectedOption,
            value: {
              ...selectedOption.value,
              switchState: !selectedOption.value.switchState,
            },
          }
        : selectedOption,
    );
    this.onChange(items);
  };

  render() {
    const {
      options,
      inline,
      title,
      meta,
      optionWidth,
      required,
      switchLabel,
      disabled,
      disabledSwitch,
    } = this.props;

    const error = required
      ? meta.touched && meta.error
      : (meta.touched || meta.dirty) && meta.error;

    return (
      <Container>
        <FormLabel required={required} error={error}>
          {title}
        </FormLabel>
        <FormGroup row={inline}>
          {options.map((option: DictionaryItem) => (
            <FormGroupContentWrapper key={option.value?.id} width={optionWidth}>
              <FormControlLabel
                labelPlacement="end"
                control={
                  <Checkbox
                    checked={!!this.getIsCheckboxSelected(option)}
                    onChange={this.onChangeCheckbox(option)}
                    name={option.label}
                    color="primary"
                    size="small"
                    disabled={disabled}
                  />
                }
                label={option.label}
              />
              <FormControlLabel
                label={switchLabel}
                labelPlacement="end"
                control={
                  <Switch
                    checked={!!this.getIsSwitchSelected(option)}
                    disabled={
                      disabledSwitch ||
                      disabled ||
                      !this.getIsCheckboxSelected(option)
                    }
                    onClick={this.onChangeSwitch(option)}
                    color="primary"
                    size="small"
                  />
                }
              />
            </FormGroupContentWrapper>
          ))}
        </FormGroup>
        {error && <FormControlError error={error} />}
      </Container>
    );
  }
}

export default withFieldControl(CheckboxGroupWithSwitchFieldControl);
